import { FormInstance } from "antd/es/form";
import React from "react";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IAccountDeletion_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IAccountDeletion_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
}

export class AccountDeletion_ScreenBase extends React.PureComponent<
  IAccountDeletion_ScreenProps,
  any
> {
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "dd595f37-448c-471a-88eb-09f90a7b9d5e",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 33273,
          PropertyName: "value",
          Value:
            "ACCOUNT AND DATA DELETION POLICY (EN) This page explains the process for requesting the deletion of accounts and personal data within the Pastel Design Boss Screen Mobile Application (“Application”).",
        },
        {
          Id: 564375,
          PropertyName: "value",
          Value:
            "1. Scope Users may request the deletion of: Their user accounts Personal data Application usage data in full or in part.",
        },
        {
          Id: 469913,
          PropertyName: "value",
          Value:
            "2. How to Submit a Request Users can submit account or data deletion requests via: Email: info@woolknot.com The following information must be included: Full Name Username Company Name This information is required to verify the identity of the requester.",
        },
        {
          Id: 390255,
          PropertyName: "value",
          Value:
            "3. Processing Time All requests are processed after identity verification Requests are completed within 7 (seven) business days Additional verification may be requested if necessary",
        },
        {
          Id: 417105,
          PropertyName: "value",
          Value:
            "4. Data to be Deleted Upon request, the following data will be deleted: User account and profile information Identity and contact details Application usage data and logs (except where legally required)",
        },
        {
          Id: 609088,
          PropertyName: "value",
          Value:
            "5. Data Retention (Legal Obligations) Certain data may be retained due to legal obligations, including: Invoice and order records Financial and accounting data Legally required records Such data is retained strictly for compliance purposes and not used otherwise.",
        },
        {
          Id: 805286,
          PropertyName: "value",
          Value:
            "6. Data Security During the deletion process: Appropriate security measures are applied Data handling is performed in a controlled environment",
        },
        {
          Id: 835658,
          PropertyName: "value",
          Value:
            "7. Contact For account and data deletion requests: Email: mert@detayyazilim.net",
        },
        {
          Id: 944710,
          PropertyName: "value",
          Value:
            "HESAP VE VERİ SİLME POLİTİKASI (TR) Bu sayfa, Pastel Design Patron Uygulaması (“Uygulama”) kullanıcılarının hesap ve kişisel verilerinin silinmesine ilişkin süreçleri açıklamaktadır.",
        },
        {
          Id: 775752,
          PropertyName: "value",
          Value:
            "1. Kapsam Kullanıcılar, uygulama kapsamında oluşturdukları: Kullanıcı hesaplarının Kişisel verilerinin Uygulama kullanım verilerinin tamamının veya bir kısmının silinmesini talep edebilir.",
        },
        {
          Id: 542870,
          PropertyName: "value",
          Value:
            "2. Hesap ve Veri Silme Talebi Oluşturma Kullanıcılar, hesap veya veri silme taleplerini aşağıdaki yöntem ile iletebilir: E-posta: mert@detayyazilim.net Talep iletilirken aşağıdaki bilgilerin paylaşılması gerekmektedir: Ad Soyad Kullanıcı Adı Firma Adı Bu bilgiler, talebin doğru kullanıcıya ait olduğunun doğrulanması amacıyla talep edilmektedir.",
        },
        {
          Id: 613322,
          PropertyName: "value",
          Value:
            "3. Talep Süreci ve Süresi Tüm talepler güvenlik doğrulamasından sonra işleme alınır Talepler en geç 7 (yedi) iş günü içerisinde sonuçlandırılır Gerekli durumlarda kullanıcı ile ek doğrulama için iletişime geçilebilir",
        },
        {
          Id: 319787,
          PropertyName: "value",
          Value:
            "4. Silinen Veriler Talep doğrultusunda aşağıdaki veriler silinir: Kullanıcı hesabı ve profil bilgileri Kimlik ve iletişim bilgileri Uygulama kullanım verileri ve log kayıtları (yasal zorunluluklar hariç)",
        },
        {
          Id: 451020,
          PropertyName: "value",
          Value:
            "5. Saklanan Veriler (Yasal Yükümlülükler) Aşağıdaki veriler, ilgili mevzuat gereği silinmeyebilir ve belirli sürelerle saklanabilir: Fatura ve sipariş kayıtları Finansal ve muhasebesel veriler Yasal zorunluluk kapsamında tutulması gereken kayıtlar Bu veriler yalnızca yasal yükümlülüklerin yerine getirilmesi amacıyla saklanır ve başka bir amaçla kullanılmaz.",
        },
        {
          Id: 610898,
          PropertyName: "value",
          Value:
            "6. Veri Güvenliği Silme talepleri işlenirken: Yetkisiz erişimlere karşı güvenlik önlemleri uygulanır Veri işleme süreçleri kontrollü şekilde yürütülür",
        },
        {
          Id: 835629,
          PropertyName: "value",
          Value:
            "7. İletişim Hesap ve veri silme talepleriniz için: E-posta: mert@detayyazilim.net",
        },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("accountdeletion", "");
      return;
    }

    this.fillFormInitValues();
    if (true) {
    }

    KuikaAppManager.calculateAndSetBodyHeight("accountdeletion", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("accountdeletion", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
